// Initialiser Alertify
window.initializeAlertify = function() {
  var alertify = require('alertify/alertify')

  alertify.defaults.glossary.title = $('#alertify-defaults-glossary-confirm-title').text();
  alertify.defaults.glossary.ok = $('#alertify-defaults-glossary-ok').text();
  alertify.defaults.glossary.cancel = $('#alertify-defaults-glossary-cancel').text();
  alertify.defaults.transition = "slide";
  alertify.defaults.theme.ok = "btn btn-primary";
  alertify.defaults.theme.cancel = "btn btn-danger";
  alertify.defaults.theme.input = "form-control";

  return alertify
}
// initializeAlertify();

$(document).on("turbolinks:load", function(){
  var alertify = initializeAlertify();
});
